export enum SELECTION_TYPE {
  EXCLUDE = 'exclude',
  INCLUDE = 'include',
}
